
import AppChatConversation from "@/components/chat/ChatConversation.vue";
import AppThreadModal from "@/components/chat/NewThreadModal.vue";
import { Conversation } from "@/models/chat/conversation";
import { ChatService } from "@/services/chat-service";
import { ChatState } from "@/utils/chat-state";
import Vue from "vue";

export default Vue.extend({
	data() {
		return {
			msgInput: "",
			dragCount: 0,
			conversation: new Conversation(),
			message: "",
			file: null as null | File,
			ready: false,
			showAddThreadModal: false
		};
	},
	props: {
		state: {
			type: Object as () => ChatState,
			required: true
		}
	},
	watch: {
		"$route.params.channelId"(to, from) {
			this.fetch();
		}
	},
	methods: {
		async fetch() {
			this.conversation = await ChatService.getChannelConversation(
				this.$route.params.channelId
			);
			this.state.openedConversation = this.conversation;
			this.ready = true;
		},
		toggleNewThread() {
			this.showAddThreadModal = true;
		}
	},
	beforeDestroy() {},
	async created() {
		await this.fetch();
	},
	components: {
		AppChatConversation,
		AppThreadModal
	},
	i18nEx: {
		componentPrefix: "views.ChatChannel"
	}
});
